import { createMiddlewareAction } from './createMiddlewareAction'
import {
  endpointsContactHospitals,
  endpointsPresentaciones,
} from '../api/endpoints'
import { presentationsTypes } from '../constantes/actionTypes'

export const presentationsActions = {
  getAllPresentations: () =>
    createMiddlewareAction({
      successType: presentationsTypes.GET_ALL_PRESENTATIONS_SUCCESS,
      failureType: presentationsTypes.GET_ALL_PRESENTATIONS_FAILURE,
      method: 'GET',
      endpoint: endpointsPresentaciones.GET_ALL_PRESENTATIONS,
    }),
  getPresentationById: (id) =>
    createMiddlewareAction({
      successType: presentationsTypes.GET_PRESENTATION_BY_ID_SUCCESS,
      failureType: presentationsTypes.GET_PRESENTATION_BY_ID_FAILURE,
      method: 'GET',
      endpoint: endpointsPresentaciones.GET_PRESENTATION_BY_ID(id),
    }),
  getAllPresentationsMine: () =>
    createMiddlewareAction({
      successType: presentationsTypes.GET_ALL_PRESENTATIONS_SUCCESS,
      failureType: presentationsTypes.GET_ALL_PRESENTATIONS_FAILURE,
      method: 'GET',
      endpoint: endpointsPresentaciones.GET_ALL_PRESENTATIONS_MINE,
    }),
  getAllPresentationsByTitlePaged: (search, page, id_Usuario) =>
    createMiddlewareAction({
      successType:
        presentationsTypes.GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_SUCCESS,
      failureType:
        presentationsTypes.GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_FAILURE,
      method: 'GET',
      endpoint: endpointsPresentaciones.GET_ALL_PRESENTATIONS_BY_TITLE_PAGED(
        search,
        page,
        id_Usuario,
      ),
    }),
  newPresentationContactHospital: (presentation) =>
    createMiddlewareAction({
      successType:
        presentationsTypes.NEW_PRESENTATIONS_CONTACT_HOSPITAL_SUCCESS,
      failureType:
        presentationsTypes.NEW_PRESENTATIONS_CONTACT_HOSPITAL_FAILURE,
      method: 'POST',
      endpoint: endpointsContactHospitals.NEW_CONTACTS_PRESENTATIONS,
      body: presentation,
    }),
  //Elimina la presentación sus contactos y sus docuementos de los productos
  deletePresentation: (id) =>
    createMiddlewareAction({
      successType: presentationsTypes.DELETE_PRESENTATIONS_SUCCESS,
      failureType: presentationsTypes.DELETE_PRESENTATIONS_FAILURE,
      method: 'DELETE',
      endpoint: endpointsPresentaciones.DELETE_PRESENTATIONS(id),
    }),
  //update presentation -> enviar presentacion a un contacto
  sendPresentationToContact: (id_ContactoPresentacion) =>
    createMiddlewareAction({
      successType: presentationsTypes.UPDATE_PRESENTATIONS_SUCCESS,
      failureType: presentationsTypes.UPDATE_PRESENTATIONS_FAILURE,
      method: 'POST',
      endpoint: endpointsContactHospitals.SEND_PRESENTATION_TO_CONTACT(
        id_ContactoPresentacion,
      ),
    }),
  clearPresentationsList: () => ({
    type: presentationsTypes.CLEAR_PRESENTATIONS_LIST,
  }),
}
